import * as H from 'history';
import { FilterSerializer } from './FilterSerializer';
import { UrlEquipService } from './UrlEquipService';

export class UrlEquipServiceFactory {
    constructor(private readonly filterSerializer: FilterSerializer) {
    }

    public create(history: H.History) {
        return new UrlEquipService(this.filterSerializer, history);
    }
}
